<template>
  <vs-popup class="customer-site-create-popup"
            id="popup"
            title="CREATE PRODUCT ORDER COURIER SHIPMENT"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <h5 class="mb-2">Select product items</h5>


      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

        <vs-table :onlyClickCheckbox="true" stripe class="mb-8" multiple v-model="selected" :data="product_order_items">

        <template slot="thead">
          <vs-th width="25%" >CODE</vs-th>
          <vs-th width="25%" >QUANTITY (KG)</vs-th>
          <vs-th width="15%" >SELECTED QUANTITY (KG)</vs-th>
          <vs-th width="25%" class="text-xs">ITEM STATUS</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].formulation_code">
              {{ data[indextr].formulation_code  }}
            </vs-td>

            <vs-td :data="data[indextr].quantity">
              {{ Number(data[indextr].quantity).toFixed(2) }}
            </vs-td>

            <vs-td :data="data[indextr].quantity">
              <ValidationProvider :vid="indextr+'selected_qty'" :name="indextr+'selected_qty'" :rules="'maxoq:'+data[indextr].quantity" v-slot="{ errors }">
                <vs-input type="text" v-model="data[indextr].selected_qty" class="w-full"
                          :name="indextr+'selected_qty'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather"/>
              </ValidationProvider>

            </vs-td>

            <vs-td :data="data[indextr].item_status">
              {{ data[indextr].item_status }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>




          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_id" name="supplier_id" rules="required" v-slot="{ errors }">
                <small class="label">Courier Supplier</small>
                <v-select :clearable="false" label="company_name" v-model="createForm.supplier_id" :reduce="option => option.id" :options="courier_suppliers" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-1/2">
              <ValidationProvider vid="date_of_booking" name="date_of_booking" rules="required" v-slot="{ errors }">
                <small class="label">Date of booking</small>
                <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}" v-model="createForm.date_of_booking" placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="createForm.date_of_booking"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/2">
              <ValidationProvider vid="estimated_delivery_date" name="estimated_delivery_date" rules="required" v-slot="{ errors }">
                <small class="label">Estimated delivery date</small>
                <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}" v-model="createForm.estimated_delivery_date" placeholder="Choose Date"
                />
                <flat-pickr
                  class="w-full"
                  :config="{ dateFormat: 'd/m/Y'}"
                  v-model="createForm.estimated_delivery_date"
                  placeholder="Choose Date"
                />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="cost_of_delivery" name="cost_of_delivery" rules="required" v-slot="{ errors }">
                <small class="label">Cost of delivery (GBP)</small>
                <vs-input v-model="createForm.cost_of_delivery"  name="cost_of_delivery" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="booking_reference_number" name="booking_reference_number" rules="required" v-slot="{ errors }">
                <small class="label">Booking ref number</small>
                <vs-input v-model="createForm.booking_reference_number"  name="booking_reference_number" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const CourierRepository = RepositoryFactory.get('courier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      createForm: {
        address: {}
      },
      id: '',
      selected: [],
      product_order_items: [],
      courier_suppliers: [],
      countryCodes: [],
      customerUsers: []
    }
  }

export default {
  name: 'CreateProductOrderShipmentPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())

        this.id = this.$route.params.id
        await this.getProductOrderDetails()
        await this.fetchApprovedCourierShipments()
        this.open = true;
      } catch (error) {

      }
    },

    async getProductOrderDetails() {
      await this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getCustomerProductOrder(this.id)).data
        this.product_order_items = data.formulation_items.map((n) => {
          const qty = Number(n.quantity).toFixed(2)
          const already_shipped_qty = n.courier_shipments.reduce((a, b) => a + Number(b.quantity), 0)
          n.quantity = qty - Number(already_shipped_qty).toFixed(2)
          n.selected_qty = n.quantity
          return n
        }).filter((x) => Number(x.quantity) > 0)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      this.dataLoaded = true
    },

    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createForm.cost_of_delivery = Number(this.createForm.cost_of_delivery).toFixed(2)
         this.createForm.product_items = this.selected.map((n) => {
           return { item_id: n.id, quantity: n.selected_qty+'' }
         })
         await CourierRepository.createProductItemCourierShipment(this.createForm)
         this.showSuccessMessage('Courier shipment created')
         await vue.$parent.refreshItems()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchApprovedCourierShipments() {
      this.$vs.loading()
      const {data} = await CourierRepository.getLIstOfApprovedCourierSuppliers(1, '', 50, '')
      this.courier_suppliers =  data.data
      this.$vs.loading.close()
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
